import { useDispatch, useSelector } from "react-redux";
import { setDrawSet } from "../../redux/items/DrawSet";
import { showMaintenance } from "../../redux/items/Maintenance";
import { Fetch2 } from "../../utils/functions";
import { setDialogLogin } from "../../redux/items/DialogLogin";

const FetchNoLogin = (url, v2 = {}) => {
	const dispatch = useDispatch();
	const callback2 = false || v2.callback;
	const DialogLogin = useSelector((state) => state.DialogLogin);

	v2.callback = (cb) => {
		if (process.env.REACT_APP_YES_APP !== undefined) {
			if (!cb.response.success) {
				if (cb.response.message === "token is required") {
					dispatch(setDialogLogin(true));
				}
			}
			if (cb.response.success) {
				if (cb?.response?.data?.user?.token !== undefined) {
					if (DialogLogin) {
						dispatch(setDialogLogin(false));
					}
				}
			}
		}

		if (cb.response?.maintenance) dispatch(showMaintenance());

		if (v2?.drawSet === undefined) {
			if (cb.response.data?.drawSet) {
				dispatch(setDrawSet(cb.response.data.drawSet));
			}
		}

		if (callback2) callback2(cb);
	};

	return Fetch2(url, v2);
};

export default FetchNoLogin;
